import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const TDIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="TD" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#E11C1B"
        fillRule="evenodd"
        d="M11.2 0H16v12h-4.8V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0h5.6v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#FBCD17"
        fillRule="evenodd"
        d="M4.8 0h6.4v12H4.8V0Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
